import { render, staticRenderFns } from "./RowVehicle.vue?vue&type=template&id=6641b47a"
import script from "./RowVehicle.vue?vue&type=script&lang=js"
export * from "./RowVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports